import {
  Autocomplete,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  MenuItem,
  TextField,
  Typography,
} from "@mui/material";
import NotificationAddIcon from "@mui/icons-material/NotificationAdd";
import StocksAlertsTable from "./StocksAlertsTable";
import { useEffect, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import toast from "react-hot-toast";
import axios from "axios";
import { axiosConfig } from "../../axios/axiosConfig";
const StockForAlerts = () => {
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({
    stock_id: "",
    recommendation: "Green",
  });
  const [loading, setLoading] = useState(false);
  const [stockData, setStockData] = useState([]);
  const [tableLoading, setTableLoading] = useState(false);
  const [symbolOptions, setSymbolOptions] = useState([]);
  const [symbolLoading, setSymbolLoading] = useState(false);
  const fetchStocksForAlerts = async () => {
    setTableLoading(true);
    try {
      const response = await axiosConfig({
        method: "get",
        url: `/predictions/stocks-for-alerting-admin`,
      });
      setStockData(response?.data?.stocks_list || []);
    } catch (error) {
      const errMsg =
        error?.response?.data?.response ||
        error.message ||
        "Failed to fetch stock alerts";
      toast.error(errMsg);
    } finally {
      setTableLoading(false);
    }
  };

  const fetchStockSymbols = async () => {
    setSymbolLoading(true);
    try {
      const response = await axiosConfig({
        method: "get",
        url: `/tnibrochart/all-symbol`,
      });
      setSymbolOptions(response?.data?.symbols || []);
    } catch (error) {
      const errMsg =
        error?.response?.data?.response ||
        error.message ||
        "Failed to fetch stock symbols";
      toast.error(errMsg);
    } finally {
      setSymbolLoading(false);
    }
  };

  useEffect(() => {
    fetchStocksForAlerts();
    fetchStockSymbols();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const handleSubmit = async () => {
    setLoading(true);
    try {
      const response = await axiosConfig({
        method: "post",
        url: `/predictions/stocks-for-alerting`,
        data: form,
      });
      const data = response?.data?.response || "Stock alert added successfully";
      console.log(response, "response");
      toast.success(data);
      setOpen(false);
      setForm({
        stock_id: "",
        recommendation: "Green",
      });
      fetchStocksForAlerts();
    } catch (error) {
      const errMsg =
        error?.response?.data?.response ||
        error.message ||
        "Failed to submit form";
      toast.error(errMsg);
    } finally {
      setLoading(false);
    }
  };
  const handleDelete = async (row) => {
    try {
      const response = await axiosConfig({
        method: "delete",
        url: `/predictions/stocks-for-alerting`,
        data: { id: row.id },
      });
      const data =
        response?.data?.response || "Stock alert deleted successfully";
      toast.success(data);
      fetchStocksForAlerts();
    } catch (error) {
      const errMsg =
        error?.response?.data?.response ||
        error.message ||
        "Failed to delete alert";
      toast.error(errMsg);
    }
  };

  const handleUpdate = async (row, updates) => {
    try {
      const response = await axiosConfig({
        method: "patch",
        url: `/predictions/stocks-for-alerting`,
        data: {
          id: row.id,
          recommendation: updates.recommendation ?? row.recommendation,
          is_active:
            updates.is_active !== undefined ? updates.is_active : row.is_active,
        },
      });
      const data =
        response?.data?.response || "Stock alert updated successfully";
      toast.success(data);
      fetchStocksForAlerts();
    } catch (error) {
      const errMsg =
        error?.response?.data?.response || error.message || "Update failed";
      toast.error(errMsg);
    }
  };
  return (
    <>
      <Box sx={{ p: 3, background: "#eef2f7", minHeight: "100vh" }}>
        {/* Page Header */}
        <Box
          sx={{
            background: "#04343a",
            borderRadius: "12px",
            boxShadow: "0 4px 20px rgba(4,52,58,0.3)",
            p: "20px 28px",
            mb: 3,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            <NotificationAddIcon sx={{ color: "#fff", fontSize: 32 }} />
            <Box>
              <Typography sx={{ color: "#fff", fontWeight: 700, fontSize: "20px" }}>
                Stock for Alerts
              </Typography>
              <Typography sx={{ color: "rgba(255,255,255,0.65)", fontSize: "13px" }}>
                Manage stocks eligible for alerting
              </Typography>
            </Box>
          </Box>
          <Button
            variant="contained"
            onClick={() => setOpen(true)}
            sx={{
              background: "#016551",
              borderRadius: "8px",
              fontWeight: 600,
              px: 3,
              boxShadow: "0 4px 12px rgba(1,101,81,0.3)",
              "&:hover": {
                background: "linear-gradient(135deg, #1db954 0%, #17a349 100%)",
                boxShadow: "0 6px 16px rgba(1,101,81,0.4)",
              },
            }}
          >
            Add Alerts
          </Button>
        </Box>

        {/* Table Card */}
        <Box
          sx={{
            background: "#ffffff",
            borderRadius: "12px",
            border: "1px solid #e2e8f0",
            boxShadow: "0 1px 6px rgba(0,0,0,0.07)",
            overflow: "hidden",
          }}
        >
          <StocksAlertsTable
            stockData={stockData}
            loading={tableLoading}
            handleDelete={handleDelete}
            handleUpdate={handleUpdate}
          />
        </Box>
      </Box>

      {/* Dialog for Add Alerts */}
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            overflowX: "hidden",
            position: "relative",
            borderRadius: "12px",
          },
        }}
      >
        <DialogTitle
          sx={{
            background: "#04343a",
            color: "#fff",
            fontWeight: 700,
            fontSize: "18px",
            pb: 2,
          }}
        >
          Add New Stock Alert
        </DialogTitle>
        <IconButton
          onClick={() => setOpen(false)}
          sx={{ position: "absolute", right: 8, top: 8, color: "#fff" }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent sx={{ pt: 3 }}>
          <Autocomplete
            loading={symbolLoading}
            options={symbolOptions}
            getOptionLabel={(option) =>
              `${option.name} - ${option.company_name || ""}`
            }
            value={
              symbolOptions.find((s) => s.id === parseInt(form.stock_id)) ||
              null
            }
            onChange={(event, newValue) => {
              setForm((prev) => ({
                ...prev,
                stock_id: newValue ? newValue.id : "",
              }));
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Select Stock"
                margin="dense"
                variant="outlined"
              />
            )}
          />
          <TextField
            margin="dense"
            label="Recommendation"
            name="recommendation"
            select
            fullWidth
            variant="outlined"
            value={form.recommendation}
            onChange={handleChange}
          >
            <MenuItem value="Green">Green</MenuItem>
            <MenuItem value="Red">Red</MenuItem>
          </TextField>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button
            variant="contained"
            onClick={handleSubmit}
            sx={{
              background: "linear-gradient(135deg, #016551, #014d3d)",
              borderRadius: "8px",
              fontWeight: 600,
              px: 4,
              "&:hover": {
                background: "linear-gradient(135deg, #1db954 0%, #17a349 100%)",
              },
            }}
          >
            Submit
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default StockForAlerts;
